export default __webpack_public_path__ + "static/media/cookiesicon.c88a6d83.svg";